import { jsx as _jsx } from "react/jsx-runtime";
import { LockOutlined, Public, AssignmentInd } from "@mui/icons-material";
var TripPrivacyDetails = {
    public: {
        label: "Open to All.",
        subText: "No invitation needed",
        subAction: "Join public trip",
        description: "Anyone can join this trip. No invitation or approval needed.",
        color: "#1b5e20", // deep green
        backgroundColor: "#e8f5e9", // light green
        borderColor: "#a5d6a7",
        iconComponent: _jsx(Public, { fontSize: "small" }),
        //icon: <PublicIcon fontSize="small" />,
        icon: true,
    },
    "invite-only": {
        label: "Invitation Only.",
        subText: "Limited to selected members",
        subAction: "Invitation required",
        description: "This trip is limited to selected participants. You'll need an invite to join.",
        color: "#6a1b9a", // purple tone
        backgroundColor: "#f3e5f5",
        borderColor: "#ce93d8",
        iconComponent: _jsx(LockOutlined, { fontSize: "small" }),
        //icon: <LockIcon fontSize="small" />,
        icon: true,
    },
    approval: {
        label: "Approval Required.",
        subText: "Organizer reviews requests",
        subAction: "Request to join this trip",
        description: "Request to join this trip. The organizer will review and approve participation.",
        color: "#e65100", // orange tone
        backgroundColor: "#fff3e0",
        borderColor: "#ffcc80",
        iconComponent: _jsx(AssignmentInd, { fontSize: "small" }),
        //icon: <ApprovalIcon fontSize="small" />,
        icon: true,
    },
};
export default TripPrivacyDetails;
